import React from 'react';
import { HeaderBarLink } from '@axiom/ui';
import { Link, useLocation } from 'react-router';

export const AuthenticatedHeaderMenuItem = ({
  children,
  name,
  target,
  url,
}: {
  children: React.ReactNode;
  name: string;
  target?: string;
  url: string;
}) => {
  const location = useLocation();
  const isExternal = url.startsWith('http://') || url.startsWith('https://');

  return (
    <HeaderBarLink selected={location.pathname.includes(url)} name={name}>
      {isExternal || target ? (
        <a href={url} target={target} rel="noopener noreferrer">
          {children}
        </a>
      ) : (
        <Link to={url}>{children}</Link>
      )}
    </HeaderBarLink>
  );
};
